import { useEffect, useState } from 'react';

export const useDebouncedSearch = <T>(
    query: string,
    fetcher: (q: string) => Promise<T[]>,
    delayMs = 300,
): { results: T[]; loading: boolean; error: Error | null } => {
    const [results, setResults] = useState<T[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<Error | null>(null);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        setError(null);

        const timeout = setTimeout(() => {
            fetcher(query)
                .then((items) => {
                    if (cancelled) {
                        return;
                    }
                    setResults(items);
                    setLoading(false);
                })
                .catch((e: unknown) => {
                    if (cancelled) {
                        return;
                    }
                    setResults([]);
                    setError(e instanceof Error ? e : new Error(String(e)));
                    setLoading(false);
                });
        }, delayMs);

        return () => {
            cancelled = true;
            clearTimeout(timeout);
        };
        // oxlint-disable-next-line react-hooks/exhaustive-deps
    }, [query, delayMs]);

    return { results, loading, error };
};
